<template>
  <div class="login_container">
    <b-row class="login-row">
      <b-col class="text-center">
        <img src="@/assets/logo.png" width="100" height="100" />
        <h3>Réinitialisez votre mot de passe</h3>
      </b-col>
    </b-row>

    <b-row v-if="successMessage || errorMessage" class="mt-4">
      <b-col cols="3"></b-col>

      <b-col class="text-center">
        <b-alert v-if="errorMessage" show variant="danger">
          {{ errorMessage }}
        </b-alert>

        <b-alert v-else show variant="success">
          {{ successMessage }}
        </b-alert>
      </b-col>

      <b-col cols="3"></b-col>
    </b-row>

    <b-row class="login-row mt-4">
      <b-col>
        <b-form class="login" @submit="triggerChangePassword">
          <b-form-group class="login__input p-3">
            <b-row>
              <b-col cols="1" class="login__input-previous"> </b-col>

              <b-col>
                <b-form-input
                  v-model="email"
                  @keydown.enter="triggerChangePassword"
                  type="email"
                  placeholder="Enter your email address"
                  required
                ></b-form-input>
              </b-col>

              <b-col cols="1" class="registration__input-next">
                <spinner v-if="isSending" size="sm" />

                <img
                  @click="triggerChangePassword"
                  v-else
                  :src="require(`@/assets/icons/next.svg`)"
                  class="float-right cursor-pointer mt-2"
                  height="20"
                  width="20"
                />
              </b-col>
            </b-row>
          </b-form-group>

          <div>
            <div class="input__error" v-if="!$v.email.required">Le champ est requis.</div>
            <div class="input__error" v-if="!$v.email.email">L'email n'est pas valide.</div>
          </div>

          <p class="mt-4 text-center">
            <em>Déjà un compte ? <router-link :to="{ name: 'login' }">Connectez-vous.</router-link>.</em>
          </p>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RESET_PASSWORD } from "@/store/actions";

import { BRow, BCol, BForm, BFormGroup, BFormInput, BAlert } from "bootstrap-vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

import Spinner from "@/components/Spinner";

export default {
  name: "ResetPassword",
  components: { BRow, BCol, BForm, BFormGroup, BFormInput, BAlert, Spinner },
  mixins: [validationMixin],
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "hasErrors"]),
  },
  data: () => ({
    email: null,

    errorMessage: null,
    successMessage: null,

    isSending: false,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.isAuthenticated) next({ name: "dashboard" });
    });
  },
  methods: {
    ...mapActions("auth", { resetPassword: RESET_PASSWORD }),
    async triggerChangePassword(event) {
      if (event) event.preventDefault();

      this.errorMessage = null;
      this.successMessage = null;
      this.isSending = true;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.isSending = false;
        return;
      }

      const { email } = this;
      const result = await this.resetPassword({ email });

      this.isSending = false;
      if (result === "success")
        this.successMessage = "Un e-mail avec un lien de réinitialisation vous a été envoyé. Pensez à vérifier vos SPAMs.";
      else this.errorMessage = "L'adresse e-mail n'est pas valide.";
    },
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
</script>

<style lang="scss" scoped>
.login_container {
  padding-top: 30vh;
}
.login-row {
  margin: auto;
  width: 100%;
  max-width: 700px;
}
.login__input {
  border: 1px solid #292037;
  border-radius: 15px;
  background-color: #211932;
  color: #9593a2;
  font-size: 18px;

  input {
    width: 90%;
    background: transparent;
    border: 0px;
    color: #fff;
    font-size: 18px;
  }

  .login__input-next {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    transition: transform 0.7s ease-in-out;
  }
}

@media screen and (max-width: 576px) {
  .login_container {
    margin-top: 18vh;
  }
}
</style>
